module.exports = __webpack_public_path__ + "static/media/LOGO.b8870157.svg";